import { Robot } from "../../models/Robot";
import { RobotStatusInfo } from "./EditDeploymentPage";
import { Wifi2Bar } from "@mui/icons-material";

export function RobotConnectionStatus({
  robot,
  statusInfo
}: {
  robot: Robot,
  statusInfo?: RobotStatusInfo
}) {
  return <Wifi2Bar fontSize="large" color={statusInfo ? "success" : "disabled"} />;
}